export function treatKeydownAsClick(event, keyList) {
    var _a;
    if (keyList.includes(event.key)) {
        const saveActiveElement = document.activeElement;
        (_a = event.target) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new window.MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': true
        }));
        event.preventDefault();
        event.stopPropagation();
        saveActiveElement.focus();
    }
}
export function treatSpaceOrEnterAsClick(event) {
    treatKeydownAsClick(event, ['Enter', ' ']);
}
